export enum UserExportColumn {
    FirstName = "First Name",
    LastName = "Last Name",
    Email = "Email",
    Role = "Role",
    MFAEnabled = "MFA Enabled",
    CreditsUsed = "Credits Used This Month",
    CreatedAt = "Created At",
}

export const ORGANIZATION_CONFIG = {}
